import React from 'react';
import RenderSponsoredTitle from './RenderSponsoredTitle';

const ReturnSponsoredTitle = () => {
  return <RenderSponsoredTitle />;
};

export default ReturnSponsoredTitle;
